import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrain = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 53.66667 53.65984",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "brain" }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M50.83559,44.28741a2.77178,2.77178,0,0,0-2.24866,2.25173.04119.04119,0,0,1-.08178,0,2.772,2.772,0,0,0-2.25137-2.25174.04121.04121,0,0,1,0-.08182,2.7679,2.7679,0,0,0,2.25135-2.24811.04119.04119,0,0,1,.08178,0,2.76772,2.76772,0,0,0,2.24864,2.24811A.04121.04121,0,0,1,50.83559,44.28741Z",
			style: { fill: "#2b3273" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.71063,4.86279A2.78092,2.78092,0,0,0,45.45455,7.122a.04132.04132,0,0,1-.082,0,2.78114,2.78114,0,0,0-2.25882-2.25918.04134.04134,0,0,1,0-.08209,2.77707,2.77707,0,0,0,2.2588-2.25554.04132.04132,0,0,1,.082,0A2.77684,2.77684,0,0,0,47.71062,4.7807.04135.04135,0,0,1,47.71063,4.86279Z",
			style: { fill: "#2b3273" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.9753,9.31437a.86326.86326,0,0,0-.70035.70131.01283.01283,0,0,1-.02547,0,.86334.86334,0,0,0-.7012-.70131.01283.01283,0,0,1,0-.02548.8621.8621,0,0,0,.7012-.70018.01283.01283,0,0,1,.02547,0,.862.862,0,0,0,.70034.70018A.01283.01283,0,0,1,49.9753,9.31437Z",
			style: { fill: "#2b3273" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.44579,6.13206a4.07172,4.07172,0,0,0-3.30327,3.3078.0605.0605,0,0,1-.12013,0,4.072,4.072,0,0,0-3.30727-3.3078.06053.06053,0,0,1,0-.12019A4.06607,4.06607,0,0,0,5.02239,2.7094a.0605.0605,0,0,1,.12013,0A4.06579,4.06579,0,0,0,8.44576,6.01188.06053.06053,0,0,1,8.44579,6.13206Z",
			style: { fill: "#2b3273" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.58909,2.41855a.87948.87948,0,0,0-.71348.71446.01307.01307,0,0,1-.02595,0,.87953.87953,0,0,0-.71435-.71446.01308.01308,0,0,1,0-.026.87824.87824,0,0,0,.71434-.71331.01307.01307,0,0,1,.02595,0,.87818.87818,0,0,0,.71348.71331A.01308.01308,0,0,1,11.58909,2.41855Z",
			style: { fill: "#2b3273" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.56347,44.09553A3.00421,3.00421,0,0,0,5.12625,46.5361a.04464.04464,0,0,1-.08864,0,3.00444,3.00444,0,0,0-2.44018-2.44058.04466.04466,0,0,1,0-.08867,3,3,0,0,0,2.44016-2.43665.04464.04464,0,0,1,.08863,0,2.99983,2.99983,0,0,0,2.43722,2.43665A.04466.04466,0,0,1,7.56347,44.09553Z",
			style: { fill: "#2b3273" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.7982,48.18523a4.61179,4.61179,0,0,0-3.74138,3.74652.06853.06853,0,0,1-.13607,0,4.61206,4.61206,0,0,0-3.7459-3.74651.06856.06856,0,0,1,0-.13613,4.60534,4.60534,0,0,0,3.74588-3.74048.06853.06853,0,0,1,.13607,0,4.605,4.605,0,0,0,3.74136,3.74048A.06856.06856,0,0,1,31.7982,48.18523Z",
			style: { fill: "#2b3273" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.52075,44.57062a1.046,1.046,0,0,0-.84861.84977.01554.01554,0,0,1-.03086,0,1.04612,1.04612,0,0,0-.84964-.84977.01555.01555,0,0,1,0-.03088,1.04459,1.04459,0,0,0,.84964-.84841.01554.01554,0,0,1,.03086,0,1.04449,1.04449,0,0,0,.8486.84841A.01555.01555,0,0,1,33.52075,44.57062Z",
			style: { fill: "#2b3273" }
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.43985,41.89026S8.70013,40.98252,8.271,38.837c-2.40964,0-6.00758-5.38041-4.58821-8.58226C1.30619,27.41594-1.03743,20.25306,5.5313,17.18325c.49513-4.9513,7.427-11.81711,15.81116-9.24243,3.36689-2.90477,11.12393-4.25813,14.986,1.41937,3.70522-1.90625,9.34971,2.20333,9.74581,5.96632,2.13732-.25582,8.607,4.39841,5.43819,11.33023,2.40963,4.35715-.39611,9.30846-3.73,9.93562-.69318,2.60769-7.85606,4.45617-10.89286,1.1223-1.18832,3.73-8.90038,5.26488-11.55531,2.14556-.922,2.03-5.4648,2.66133-6.29414,2.03-.42087,1.65868-6.8328,6.0901-6.8328,6.0901S12.23206,43.89553,11.43985,41.89026Z",
				style: {
					fill: "none",
					stroke: "#2b3273",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: "2.5px"
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.68281,30.25469s6.66776-7.09687,14.35878-5.11635",
				style: {
					fill: "none",
					stroke: "#2b3273",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.22812,26.81135a21.27312,21.27312,0,0,0,2.63408-8.8689",
				style: {
					fill: "none",
					stroke: "#2b3273",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.34246,7.94082s9.60553,5.51245,6.56873,13.46754",
				style: {
					fill: "none",
					stroke: "#2b3273",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.04432,13.44571S31.41837,14.46,34.09207,13.247",
				style: {
					fill: "none",
					stroke: "#2b3273",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M36.88956,37.71466s-2.69846-9.68911,7.99635-10.67884",
				style: {
					fill: "none",
					stroke: "#2b3273",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.65619,27.03582s3.92913,2.24382,4.60113,4.60047",
				style: {
					fill: "none",
					stroke: "#2b3273",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.58542,33.52255s6.9603-1.02327,11.74883,6.33767",
				style: {
					fill: "none",
					stroke: "#2b3273",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 2
				}
			})
		] })
	] })]
});
export default SvgBrain;
